/**
 * A model for an individual corporate employee
 */
export class usersDataTable {
    id:string;
    firstName: string;
    lastName: string;
    email: string;
    region:string;
    // lastProcessedOn:string;
    country:string;
    // pubsubReadTime:string;
    role:string;
    // closureTime:string;
       
    constructor(firstName:string,lastName:string,email: string,region: string,
        country:string,role:string,id:string){
            this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.region = region;
        this.country = country;
        // this.lastProcessedOn = lastProcessedOn;
        // this.pubsubReadTime=pubsubReadTime;
        this.role = role;
       }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/users/datatable/usersDataTable.ts